<template>
  <div id="lemontreeContent" :class="[pageClassName]">
    <div id="mArticle">
      <template v-if="pageTitle || pathData.length > 0">
        <div class="head_cont">
          <h2 v-if="pageTitle" class="tit_cont"><span v-if="menuIcon" class="icon_tit">{{ menuIcon }}</span>{{ pageTitle }}</h2>
          <p v-if="pathData.length > 0" class="desc_path">
            <template
              v-for="(pathItem, index) in pathData">
              <router-link
                v-if="pathItem.routerPath && index != pathData.length-1"
                :key="`path${index}`"
                class="item_path"
                :to="$routerPath[pathItem.routerPath]">{{ pathItem.title || pathItem }}</router-link>
              <span
                v-else
                :key="`path${index}`"
                class="item_path">{{ pathItem.title || pathItem }}</span>
            </template>
          </p>
        </div>
        <div :class="['body_cont',{ 'body_cont_bg' : isBodyBg }]">
          <template v-if="isBodyMiddle">
            <div class="inner_body_middle">
              <slot />
              <div v-if="!hasSlotData" class="area_empty">
                <p class="desc_empty"><span class="icon_empty">🛠</span> 페이지 준비중</p>
              </div>
            </div>
          </template>
          <template v-else>
            <slot />
            <div v-if="!hasSlotData" class="area_empty">
              <p class="desc_empty"><span class="icon_empty">🛠</span> 페이지 준비중</p>
            </div>
          </template>
        </div>
      </template>
      <template v-else>
        <template v-if="isBodyMiddle">
          <div class="body_cont">
            <div class="inner_body_middle">
              <slot />
            </div>
          </div>
        </template>
        <template v-else>
          <slot />
        </template>
      </template>
    </div>
  </div>
</template>

<script>
import { menuData } from '@/constants/menuData';
export default{
  name:'Content',
  props:{
    isBodyBg: Boolean,
    isBodyMiddle: Boolean
  },
  beforeMount(){
    this.setPathData();
  },
  data(){
    return{
      pathData:[],
      menuIcon:''
    }
  },
  computed:{
    hasSlotData(){
      return Object.entries(this.$slots).length != 0
    },
    pageMeta(){
      return this.$route.meta;
    },
    pageTitle(){
      return ( this.pathData.slice(-1)[0] ? ( this.pathData.slice(-1)[0].title || this.pathData.slice(-1)[0] ) : this.pageMeta.title ) || '';
    },
    pageClassName(){
      return `cont_lemontree cont_${this.$route.name.toLowerCase()}`
    }
  },
  methods:{
    setPathData(){
      let pathArray = [];
      let menuDataItem = this.setPathDataItem(this.pageMeta.menuData,menuData);
      let snbMenuDataItem = {};
      let lnbMenuDataItem = {};
      
      if(menuDataItem){
        // console.log(menuDataItem);
        pathArray.push(menuDataItem.pushItem)
        snbMenuDataItem = this.setPathDataItem(this.pageMeta.snbMenuData,menuDataItem.nextData.menuList);
      }
      if(snbMenuDataItem && snbMenuDataItem.pushItem){
        // console.log(snbMenuDataItem);
        pathArray.push(snbMenuDataItem.pushItem)
        lnbMenuDataItem = this.setPathDataItem(this.pageMeta.lnbMenuData,snbMenuDataItem.nextData.menuList);
      }
      if(lnbMenuDataItem && lnbMenuDataItem.pushItem){
        // console.log(lnbMenuDataItem);
        pathArray.push(lnbMenuDataItem.pushItem)
      }
      if(this.pageMeta.title){
        pathArray.push(this.pageMeta.title)
      }
      this.pathData = pathArray;
    },
    setPathDataItem(metaData,siblingMenuDataList){
      if(!metaData) return;
      let result = {
        pushItem : metaData,
        nextData : {
          menuList:[]
        }
      };
      if(siblingMenuDataList && siblingMenuDataList.length > 0){
        const menuDataItem = siblingMenuDataList.find(item => item.id === metaData.id);
        if(menuDataItem){
          result.nextData = menuDataItem;
          if(menuDataItem.routerPath){
            result.pushItem.routerPath = menuDataItem.routerPath
          }
          if(menuDataItem.menuIcon){
            this.menuIcon = menuDataItem.menuIcon
          }
        }
      }
      return result;
    }
  }
}
</script>

<style lang="scss" scoped>
.cont_lemontree{min-height:100vh;padding-top:51px;padding-bottom:56px;background-color:$CONTENT_BG;box-sizing:border-box}
.cont_lemontree #mArticle{max-width:1400px;margin:0 auto;padding:0 0 100px}

// .cont_unrequires_auth{height:100%;min-height:100vh}
.cont_login,
.cont_logindirect{padding:0;background-color:$PRIMARY_COLOR;font-size:0;white-space:nowrap;text-align:center}
.cont_login:after,
.cont_logindirect:after{display:inline-block;height:100%;min-height:inherit;vertical-align:middle;content:''}
.cont_login #mArticle,
.cont_logindirect #mArticle{display:inline-block;width:100%;max-width:440px;padding:0 20px;vertical-align:middle;text-align:left;white-space:normal;box-sizing:border-box}

.cont_contents .body_cont{display:flex;flex-direction:column}

.head_cont{overflow:hidden;padding:34px 40px 0}
.tit_cont{display:inline-block;font-size:20px;line-height:27px;font-weight:600;vertical-align:top;color:$CONTENT_TEXT}
.tit_cont .icon_tit{display:inline-block;margin-right:8px;vertical-align:top}
.desc_path{float:right;font-weight:500;font-size:14px;line-height:21px;margin-top:6px}
.desc_path .item_path{display:inline-block;color:#555;vertical-align:top}
.desc_path a.item_path{text-decoration: underline}
.desc_path .item_path + .item_path:before{display:inline-block;margin:0 8px;color:$DISABLED_TEXT;vertical-align:top;content:'/'}

.body_cont{padding:20px 40px 40px}
// .body_cont_bg{}

.wrap_full #mArticle{padding-bottom:0}
.wrap_full .body_cont{height:calc(100vh - 51px - 56px);box-sizing:border-box;}
.wrap_full .head_cont + .body_cont{height:calc(100vh - 51px - 56px - 61px);}

.wrap_middle #mArticle{padding-bottom:0}
.wrap_middle .body_cont{display:flex;flex-direction:column;min-height:calc(100vh - 51px - 56px);justify-content:center;box-sizing:border-box}
.wrap_middle .head_cont + .body_cont{min-height:calc(100vh - 51px - 56px - 61px);}
// .wrap_middle .body_cont .inner_body_middle{}

.area_empty{padding:60px 0}
.area_empty .desc_empty{font-weight:600;font-size:16px;line-height:18px;text-align:center;color:#888}
.area_empty .desc_empty .icon_empty{display:block;margin-bottom:20px;font-size:40px;line-height:40px}

/* 모바일 */
// @media all and (max-width:1240px){
//   .cont_lemontree #mArticle{padding:20px 0 100px}
//   .cont_login #mArticle{padding:0 20px}
//   .head_cont{padding:0 20px 14px}
//   .desc_path{float:none}
//   .desc_path span + span:before{margin:0 4px}
//   .body_cont{padding:0 20px 40px}

//   .wrap_full #mArticle{padding-bottom:20px}
//   .wrap_middle .body_cont{min-height:calc(100vh - 51px - 56px - 40px )}
//   .wrap_middle .head_cont + .body_cont{min-height:calc(100vh - 51px - 56px - 40px - 68px);}
// }

@media (prefers-color-scheme: dark) {
  .cont_lemontree{background-color:$CONTENT_BG_DARK}
  .cont_login{background-color:$CONTENT_BG_DARK}
  .tit_cont{color:#fbfbfb}
  // .body_cont_bg{background-color:$CONTENT_BG_DARK}
  .desc_path span{color:#fbfbfb}
}
</style>